import { render, staticRenderFns } from "./result-item.vue?vue&type=template&id=7c59e404&scoped=true&"
import script from "./result-item.vue?vue&type=script&lang=js&"
export * from "./result-item.vue?vue&type=script&lang=js&"
import style0 from "./result-item.vue?vue&type=style&index=0&id=7c59e404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c59e404",
  null
  
)

export default component.exports